import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { AuthService, SigninForm } from '@/services/Auth';

export const useSignin = (): ((
  email: string,
  password: string
) => Promise<void>) => {
  const authService = new AuthService(getClient());
  const history = useHistory();
  const queryClient = useQueryClient();

  const signin = async (email: string, password: string) => {
    const body: SigninForm = { email, password };
    return await authService
      .signin(body)
      .then(() => {
        alert('ログインしました。');
        queryClient.clear();
        history.replace('/');
      })
      .catch((error: Error) =>
        errorHandler({ error, alertMessage: 'ログインに失敗しました' })
      );
  };

  return signin;
};
